// components/admin/DiscountUsageModal.js

import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { Link } from 'react-router-dom'; // Linkler için
import './AdminModals.css';

const API_URL = process.env.REACT_APP_API_URL;

const DiscountUsageModal = ({ isOpen, onClose, discount }) => {
    const { t } = useTranslation();
    const { token } = useAuth();
    const [usageData, setUsageData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!discount || !token) return;

        const fetchUsageData = async () => {
            setLoading(true);
            setError('');
            try {
                const response = await fetch(`${API_URL}/api/admin/discounts/${discount.id}/usage`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) throw new Error('Usage data could not be fetched.');
                const data = await response.json();
                setUsageData(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchUsageData();
    }, [discount, token]);

    if (!isOpen) return null;

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleString();
    };

    return ReactDOM.createPortal(
        <div className="admin-modal-overlay" onClick={onClose}>
            <div className="admin-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="admin-modal-header">
                    <h3>{t('discount_usage_for', { code: discount.code || discount.description })}</h3>
                    <button onClick={onClose} className="close-btn">&times;</button>
                </div>
                <div className="admin-modal-form">
                    {loading && <p>{t('loading')}...</p>}
                    {error && <p className="auth-error">{error}</p>}
                    {!loading && !error && (
                        <table className="admin-table">
                            <thead>
                                <tr>
                                    <th>{t('user')}</th>
                                    <th>{t('order_id')}</th>
                                    <th>{t('date_used')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {usageData.length === 0 ? (
                                    <tr><td colSpan="3" className="table-row-message">{t('no_usage_found')}</td></tr>
                                ) : (
                                    usageData.map(usage => (
                                        <tr key={usage.job_id}>
                                            <td>
                                               <Link to={`/management/customers/${usage.user_id}`}>
    {usage.first_name} {usage.last_name}
</Link>
                                            </td>
                                            <td>
                                                <Link to={`/management/jobs/${usage.job_id}`}>
                                                    #{usage.job_id}
                                                </Link>
                                            </td>
                                            <td>{formatDate(usage.used_at)}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    )}
                </div>
                <div className="admin-modal-footer">
                    <button type="button" onClick={onClose} className="btn-secondary">{t('close')}</button>
                </div>
            </div>
        </div>,
        document.getElementById('modal-root')
    );
};

export default DiscountUsageModal;